<template>
  <div>
    <template>
      <v-subheader>対象地域</v-subheader>
      <v-layout v-for="area in targetAreas" :key="area.id" pl-4>
        {{ area.prefectureName }} {{ area.name }}
      </v-layout>
      <v-layout pt-1 pl-4>
        {{ districtTypeStr }}ごとに配信グループを分割{{ splitGroup }}
      </v-layout>
    </template>
  </div>
</template>

<script>
import { TargetAreaTypes } from '@/models/CampaignOperation/Constants'

export default {
  name: 'CampaignModalPageConfirmArea',
  props: {
    menuSetting: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    districtTypeStr() {
      if (
        this.menuSetting.administrativeDistrictType ===
        TargetAreaTypes.PREFECTURE
      ) {
        return '都道府県'
      } else {
        return '市区町村'
      }
    },
    splitGroup() {
      if (this.menuSetting.splitGroup) {
        return 'する'
      } else {
        return 'しない'
      }
    },
    targetAreas() {
      if (
        this.menuSetting.administrativeDistrictType ===
        TargetAreaTypes.PREFECTURE
      ) {
        return this.menuSetting.area.prefectureAreaObj.prefectureIdAndNames
      } else {
        return this.menuSetting.area.cityAreaObj.prefectures
          .map(prefecture =>
            prefecture.cityIdAndNames.map(city => {
              return {
                ...city,
                prefectureName: prefecture.prefectureName,
              }
            }),
          )
          .flat()
      }
    },
  },
}
</script>
